import * as Yup from "yup";
import { form, AppendixForm } from "./form";
const checkout = form;

const {
  formField: {
    id,
    date,
    payerName,
    taxID,
    address,
    agency,
    taxRefundDocument,
    taxRefundDate,
    tradeID,
    notificationReceivingAgency,
    receivedDate,
    why,
    chiefAccountant,
    certificateNumber,
    signer,
  },
} = checkout;

const validation = Yup.object().shape({
  // [sendTo.name]: Yup.string().required(sendTo.errorMsg),
  // [accountOwner.name]: Yup.string().required(accountOwner.errorMsg),
  // [bankAccountNumber.name]: Yup.string().required(bankAccountNumber.errorMsg),
  // [bankName.name]: Yup.string().required(bankName.errorMsg),
  // [certificateNumber.name]: Yup.string().required(certificateNumber.errorMsg),
  // [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  // [documentNumber.name]: Yup.string().required(documentNumber.errorMsg),
  // [taxAgentCode.name]: Yup.string().required(taxAgentCode.errorMsg),
  // [signer.name]: Yup.string().required(signer.errorMsg),
  // [taxAgentName.name]: Yup.string().optional(),
  // [taxPayers.name]: Yup.number().required(taxPayers.errorMsg),
  // [taxCode.name]: Yup.string()
  //   .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
  //   .required(taxCode.errorMsg),
  // [whyRefund.name]: Yup.string().required(whyRefund.errorMsg),
  // [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
